<template>
  <ul>
    <li v-for="(item, idx) in getPrices()" :key="idx">
      <span>{{ item.name }}</span>
      <span class="between" v-if="!isMobile">{{ calcDots(item) }}</span>
      <span class="price-wrap">
        <span class="price">
          <span class="fw600">
            {{ item.price }}
          </span>Р
        </span>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    prices: [Array, Object],
    limit: {
      type: Boolean, default: () => {
        return true;
      }
    }
  },
  computed: {
    isMobile () {
      return document.documentElement.clientWidth < 1170
    }
  },
  methods: {
    getPrices() {
      if (!this.limit) return this.prices;
      let list = [];
      for (let index in this.prices) {
        this.prices[index].map((val) => list.push(val));
      }
      return list.slice(0, 6);
    },
    calcDots(item) {
      let words = 0
      words += item.name.length
      if (item.old_price) {
        words += item.old_price.toString().length
        /* _Р_*/
        words += 2
      }
      if (item.new_price) {
        words += item.old_price.toString().length
      }
      if (item.price) {
        words += item.price.toString().length
      }
      if (this.perHour) {
        words += 5
      }
      /*_Р/час */
      words += 6
      const dots_count = 47 - words
      const dotsArray = []
      for (let i = 0; i < dots_count; i++) {
        dotsArray.push('. ')
      }
      return dotsArray.join('')
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.4;
  }

  button {
    border: none;
    background-color: transparent;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    text-align: right;
    color: #B9765B;
  }
}

ul {
  list-style: none;

  li {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 16px;
    line-height: 1.5;

    .between {
      margin: 0 5px;
    }

    .price {
      text-align: right;
      color: #383838;
    }
  }
}

.old_price {
  font-size: 16px;
  line-height: 1.5;
  color: #808080;
  text-decoration: line-through;
  margin-right: 5px;
}

.new_price {
  font-size: 16px;
  line-height: 1.5;
  color: #E05252;
}

.price {
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
  margin-left: 5px;
}

.fw600 {
  font-weight: 600;
}
</style>
